import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// import HttpBackend from "i18next-http-backend";

import en from '../assets/locales/en/translation.json';
import ms from '../assets/locales/ms/translation.json';

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  // .use(HttpBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // backend: {
    //   // Define the path to your translation files
    //   loadPath: 'http://localhost:8080/locales/{{lng}}/{{ns}}.json',
    //   // Example: '/locales/en/translation.json'
    // },
    // debug: true,
    resources: {
      en: { translation: en },
      ms: { translation: ms },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    load: 'languageOnly',
    // lng: "ms",
  });

export default i18n;
